import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { EventHistoryDialogContainer } from '@ruby/shared/dialogs/diversions/event-history/containers/event-history-dialog.container';
import { OriginalLocationDialogContainer } from '@ruby/shared/dialogs/diversions/original-location/containers/original-location-dialog.container';
import { DiversionsWaybilllPreviewContainer } from '@ruby/shared/dialogs/diversions/waybill-preview/container/waybill-preview.container';
import { EDiversionsPaths } from '@ruby/shared/enums/diversions.enum';

@Component({
  selector: 'ng-request-detail-header',
  templateUrl: './request-detail-header.component.html',
  styleUrls: ['./request-detail-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestDetailHeaderComponent {
  @Input() waybillOwner!: string;
  @Input() waybillOwnerSequence!: string;
  @Input() waybillType!: string;
  @Input() status?: string;
  @Input() requestNumber?: string;
  @Input() carId?: Array<string>;
  @Output() print = new EventEmitter();
  @Output() useAsTemplate = new EventEmitter();

  constructor(private dialog: MatDialog, private router: Router) { }

  /**
   * Open Waybill print Dialog
   *
   * @param $printType: string
   * @summary Function to open the previous request waybill dialog
   * @return void
   */
  openWaybillDialog($printType: string): void {
    this.dialog.open(DiversionsWaybilllPreviewContainer, {
      width: '90%',
      maxWidth: '40%',
      data: {
        customerNumber: this.waybillOwner,
        customerSequence: this.waybillOwnerSequence,
        waybillType: $printType
      }
    });
  }

  /**
   * Open Event History Dialog
   *
   * @summary Open Event History Dialog
   * @returns void
   */
  openEventHistoryDialog(): void {
    this.dialog.open(EventHistoryDialogContainer, {
      data: {
        customerNumber: this.waybillOwner,
        customerSequence: this.waybillOwnerSequence,
        carId: this.carId ? this.carId[0] : '',
        requestNumber: this.requestNumber
      },
      width: '60%',
      height: '70%'
    });
  }

  /**
   * Open Original Location Dialog
   *
   * @summary Open Original Location Dialog
   * @returns void
   */
  openOriginalLocationDialog(): void {
    this.dialog.open(OriginalLocationDialogContainer, {
      data: {
        customerNumber: this.waybillOwner,
        customerSequence: this.waybillOwnerSequence
      },
      width: '85%',
      height: '70%'
    });
  }

  /**
   * Print Preview
   *
   * @summary Print Preview
   * @returns void
   */
  printPreview(): void {
    this.print.emit();
  }

  /**
   * Back To List
   *
   * @summary Will return to diversions review details list
   * @returns void
   */
  backToList(): void {
    this.router.navigate([EDiversionsPaths.PREVIOUS_REQUESTS], { state: { keepFilters: true } });
  }

  /**
   * Is Waybill Type
   *
   * @summary Checks if the selected waybill type is of the current waybill type
   * @Param $type: string
   * @returns boolean
   */
  isWaybillType($type: string): boolean {
    return this.waybillType.includes($type);
  }
}
